import IdentifyingMoney from "../../components/UKG/Mathematics/IdentifyingMoney";
import MatchMoney from "../../components/UKG/Mathematics/MatchMoney";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/ukg/mathematics/money/identifing", title: "Identifying", component: IdentifyingMoney},
    { url: "/ukg/mathematics/money/match-money", title: "Match Money", component: MatchMoney},
];


export default topics;